import clsx from "clsx";
import type { FC } from "react";

import { t } from "i18n/i18n";
import { SquareButton } from "mds/components/buttons/SquareButton";
import { LoadingDotsIcon } from "mds/icons";

interface JoinGroupButtonProps {
  kind: "tertiary" | "accent";
  disabled: boolean;
  isLoading: boolean;
  onChangeGroup: () => void;
  index: number;
}

export const JoinGroupButton: FC<JoinGroupButtonProps> = ({
  disabled,
  isLoading,
  kind,
  onChangeGroup,
  index,
}) => {
  return (
    <SquareButton
      className={clsx(isLoading && "cursor-not-allowed")}
      disabled={disabled}
      kind={kind}
      size="xs"
      title={
        disabled
          ? t("student_self_select_card.tooltip.group_full")
          : t("student_self_select_card.tooltip.become_member")
      }
      onClick={isLoading ? undefined : onChangeGroup}
    >
      {isLoading ? (
        <LoadingDotsIcon />
      ) : (
        t("common.join_group", {
          number: index + 1,
        })
      )}
    </SquareButton>
  );
};
